import React, { useMemo, useRef, useState } from 'react';
import debounce from 'lodash/debounce';
import AvatarEditor from 'react-avatar-editor';
import PropTypes from 'prop-types';
import BasicButton from '../../../../components/BasicButton';

const AvatarUploaderEditor = props => {
  const { image, size, borderRadius = size / 2, onChange, onRemove } = props;

  const refEditor = useRef();
  const [scale, setScale] = useState(1);

  const zoomStep = 0.05;
  const zoomMin = 1;
  const zoomMax = 3;

  const handlePositionChange = () => {
    onChange({
      image,
      croppingRect: getCroppingRect(),
      canvas: getCanvas(),
    });
  };

  const handleImageReady = () => {
    onChange({
      image,
      croppingRect: getCroppingRect(),
      canvas: getCanvas(),
    });
  };

  const handleImageChange = () => {
    onChange({
      image,
      croppingRect: getCroppingRect(),
      canvas: getCanvas(),
    });
  };

  const handleRemove = () => {
    refEditor.current.clearImage();
    setScale(1);
    onRemove();
  };

  const handleScale = e => {
    setScale(e.target.value);
  };

  const getCroppingRect = () => {
    const { x, y, width } = refEditor.current.getCroppingRect();
    return { x, y, width };
  };

  const getCanvas = () => {
    return refEditor.current.getImageScaledToCanvas();
  };

  const handleWheel = useMemo(
    () =>
      debounce((deltaY, scale) => {
        const s = Number(scale);
        if (deltaY < 0 && s < zoomMax) {
          const nextScale = s + zoomStep * 3;
          setScale(
            Number((nextScale > zoomMax ? zoomMax : nextScale).toFixed(2))
          );
        }
        if (deltaY > 0 && s > zoomMin) {
          const nextScale = s - zoomStep * 3;
          setScale(
            Number((nextScale < zoomMin ? zoomMin : nextScale).toFixed(2))
          );
        }
      }, 10),
    []
  );

  return (
    <div className="avatar-uploader">
      <div
        className="avatar-uploader__editor"
        onWheel={e => handleWheel(e.deltaY, scale)}
      >
        <AvatarEditor
          ref={refEditor}
          image={image}
          width={size}
          height={size}
          scale={scale}
          rotate={0}
          border={20}
          borderRadius={borderRadius}
          color={[255, 255, 255, 0.8]}
          disableBoundaryChecks={false}
          disableHiDPIScaling={false}
          onPositionChange={handlePositionChange}
          onImageChange={handleImageChange}
          onImageReady={handleImageReady}
        />
        <div>
          <input
            className="range-slider"
            name="scale"
            type="range"
            onChange={handleScale}
            value={scale}
            min={zoomMin}
            max={zoomMax}
            step={zoomStep}
          />
        </div>
        <div>
          <BasicButton
            btnText="Remove"
            btnArrow={false}
            controlFunc={handleRemove}
          />
        </div>
      </div>
    </div>
  );
};

AvatarUploaderEditor.propTypes = {
  image: PropTypes.object.isRequired,
  size: PropTypes.number.isRequired,
  borderRadius: PropTypes.number,
  position: PropTypes.shape({ x: PropTypes.number, y: PropTypes.number }),
  scale: PropTypes.number,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AvatarUploaderEditor;
